import React, { useEffect, useState } from "react";
import TrendlineUp from "../assets/TrendlineUp.svg";
import TrendlineDown from "../assets/TrendlineDown.svg";
import Dropdown_icon from "../assets/Dropdown_icon.svg";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";

const SalaryTimeline = ({
  revisions,
  formatSalary,
  formatDate,
  formatMonthSalary,
}) => {
  const [expanded, setExpanded] = useState(null);

  const handleToggle = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  return (
    <div className="p-6">
      <div className="max-w-3xl relative">
        {revisions.map((revision, index) => (
          <div key={index} className="relative">
            <div className="absolute left-4 top-0 flex flex-col items-center">
              <div
                className={`w-6 h-6 rounded-full flex items-center justify-center text-white ${revision.is_current ? "bg-teal-500" : "bg-[#267072]"
                  }`}
              >
                {revisions?.[index + 1] &&
                  revision.salary == revisions?.[index + 1]?.salary ? (
                  <TrendingFlatIcon
                    alt="Arrow Icon flat"
                    className="w-4 h-4 text-white bg-inherit rounded-full"
                  />
                ) : revision?.salary < revisions?.[index + 1]?.salary ? (
                  <img
                    src={TrendlineDown}
                    alt="Arrow Icon down"
                    className="w-4 h-4"
                  />
                ) : (
                  <img
                    src={TrendlineUp}
                    alt="Arrow Icon up"
                    className="w-4 h-4"
                  />
                )}
              </div>
            </div>
            {index < revisions.length - 1 && (
              <div className="w-0.5 h-full bg-gray-300 absolute left-[27px] top-6 flex flex-col items-center"></div>
            )}

            <div className="ml-16 pb-8 w-[calc(100%-70px)]">
              <div className="flex items-center justify-start gap-4 p-3 pt-0">
                <h3 className="font-semibold text-sm">Salary Revision</h3>
                <span className="text-sm text-gray-500">
                  {/* Effective {revision.effective_date} */}
                  Effective {formatDate(revision.effective_date)}
                </span>
                {revision.is_current && (
                  <span className="ml-2 text-xs text-white bg-teal-500 px-2 py-1 rounded-md">
                    CURRENT
                  </span>
                )}
              </div>

              <div
                className="w-full bg-white shadow-md rounded-lg p-2 px-0 cursor-pointer "
                onClick={() => handleToggle(index)}
              >
                <div className="mt-2 flex justify-start gap-4 text-gray-700 px-2">
                  <div className="mt-3 text-[#267072] hover:underline text-center">
                    {expanded === index ? (
                      <img
                        src={Dropdown_icon}
                        alt="Arrow Icon"
                        className="!w-4 !h-4 rotate-[270deg] transition"
                      />
                    ) : (
                      <img
                        src={Dropdown_icon}
                        alt="Arrow Icon"
                        className="!w-4 !h-4 rotate-180 transition"
                      />
                    )}
                  </div>
                  <p>
                    <span className="font-normal text-gray-500">
                      Regular Salary
                    </span>{" "}
                    <br />
                    INR {formatSalary(revision.salary)}
                  </p>
                  <p className=" text-center font-bold mt-3">=</p>
                  <p>
                    <span className="font-normal text-gray-500">Total</span>{" "}
                    <br />
                    INR {formatSalary(revision.salary)}
                  </p>
                </div>

                <div
                  className={`rounded-lg  transition-all duration-300 ease-in-out ${expanded === index
                    ? "max-h-[200px] scale-y-100"
                    : "max-h-0 scale-y-0"
                    }`}
                >
                  {
                    <div className=" rounded-lg p-2 px-0">
                      <div className=" d-flex justify-center align-middle w-full">
                        <div className="flex bg-gray-100 justify-center h-0.5 items-center gap-5  mb-0.5 w-full mx-2  "></div>
                      </div>

                      <div className="flex justify-between items-center gap-7 px-3">
                        <p>
                          <span className="text-sm text-gray-500">
                            Salary Per Month
                          </span>
                          <br />
                          {/* {revision.details.perMonth} */}
                          {formatMonthSalary(
                            (parseFloat(revision.salary) / 12).toFixed(2)
                          )}
                        </p>
                        <p>
                          <span className="text-sm text-gray-500">
                            Effective From
                          </span>
                          <br />
                          {formatDate(revision.effective_date)}
                        </p>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SalaryTimeline;
